// GoldSilverDashboard.jsx

import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import 'chartjs-adapter-date-fns';
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const API_KEY = "lpNjgL0Hacsgp39zIvJgmHANznD4qvNf";
const API_URL = "https://goldapi.deuslab.com/";

export default function GoldSilverDashboard() {
  const [currentPrices, setCurrentPrices] = useState({ au: null, ag: null });
  const [history, setHistory] = useState({ au: null, ag: null });
  const [grain, setGrain] = useState({ au: null, ag: null, pt:null,pd:null,cotizacion:null });
  const [lastUpdate, setLastUpdate] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [checkedAuth, setCheckedAuth] = useState(false);
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const key = params.get("key");
    if (key === API_KEY) {
      setIsAuthorized(true);
    }
    setCheckedAuth(true);
  }, []);
  
  

  useEffect(() => {
    async function fetchData() {
      const [currentRes, historyRes,grainRes] = await Promise.all([
        fetch(`${API_URL}?function=current&elements=au,ag&key=${API_KEY}`),
        fetch(`${API_URL}?function=history_hourly&elements=au,ag&hours=96&key=${API_KEY}`),
        fetch(`${API_URL}?function=grain_value&key=${API_KEY}`),
        
      ]);
      const currentData = await currentRes.json();
      const historyData = await historyRes.json();
      const grainData = await grainRes.json();
      setCurrentPrices(currentData.data);
      setHistory(historyData.data);
      setGrain(grainData.data);
      setLastUpdate(new Date());
    }

    fetchData();
    const interval = setInterval(() => {
      if (lastUpdate) {
        const diff = Date.now() - lastUpdate;
        if (diff > 24 * 60 * 60 * 1000) window.location.reload();
      }
      fetchData();
    }, 30000);

    return () => clearInterval(interval);
  }, [lastUpdate]);

  if (
    !currentPrices.au ||
    !currentPrices.ag ||
    !history.au ||
    !history.ag
  ) {
    return <div>Cargando...</div>;
  }

  const formatPrice = (price) => {
    const num = parseFloat(price);
    return num.toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    });
  };

  const formatChartData = (data) => ({
    labels: Object.keys(data),
    datasets: [
      {
        label: "Precio USD",
        data: Object.values(data),
        fill: false,
        borderColor: "#f0ad4e",
        tension: 0.1,
      },
    ],
  });

  const calculateSalePrice = (spot, multiplier, grams = 1) =>
    formatPrice(spot * grams * multiplier);

  const auGram = parseFloat(currentPrices.au.grams_price);
  const auOz = parseFloat(currentPrices.au.grams_price) * 31.1035;
  const agGram = parseFloat(currentPrices.ag.grams_price);
  const agOz = parseFloat(currentPrices.ag.grams_price) * 31.1035;
  
  const laminado_auGram = Math.round(parseFloat(grain.au.value));
  const laminado_agGram = Math.round(parseFloat(grain.ag.value));
  const laminado_ptGram = Math.round(parseFloat(grain.pt.value));
  const laminado_pdGram = Math.round(parseFloat(grain.pd.value));
  const laminado_Cotizacion =(Math.round(parseFloat(grain.cotizacion.price)*100)/100)+' - '+grain.cotizacion.date.substring(0,5);

  const getFormattedTime = () =>
    lastUpdate
      .toLocaleDateString([], { day: "2-digit", month: "2-digit", year: "numeric" })
      .concat(
        " ",
        lastUpdate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      );

  const isStale = () =>
    lastUpdate && Date.now() - lastUpdate > 5 * 60 * 60 * 1000;

  const vistaCompras =()=>{
    return (
      <>
        <div className="col-md-5 col-sm-12 pt-0">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th></th>
                <th class="fs-7">0%</th>
                <th class="fs-7">8%</th>
                <th  class="fs-7">10%</th>
                <th  class="fs-7">20%</th>
              </tr>

            </thead>
            <tbody>
              <tr>
                <td className="fs-8">Mon Au 900</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram * 0.9,1)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram * 0.9, 0.92)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram * 0.9, 0.9)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram * 0.9, 0.8)}</td>
              </tr>
              <tr>
                <td className="fs-8">Libra</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram * 0.9, 1)}/gr</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram * 0.9, 0.92)}/gr</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram * 0.9, 0.9)}/gr</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram * 0.9, 0.8)}/gr</td>
              </tr>
              <tr>
                <td className="fs-8">Ling AU 24k</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram, 1)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram, 0.92)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram, 0.9)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(auGram, 0.8)}</td>
              </tr>
              
            </tbody>
          </table>
        </div>
        <div className="col-md-4 col-sm-12 pt-0">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th class="fs-7">Sin refi</th>
                <th class="fs-7">0%</th>
                <th class="fs-7">-10%</th>
                <th  class="fs-7">-20%</th>
                <th  class="fs-7">-30%</th>
              </tr>

            </thead>
            <tbody>
              <tr>
                <td className="fs-8">Plata 900</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .9)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .9*.9)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .9*.8)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .9*.7)}</td>
              </tr>
              <tr>
                <td className="fs-8">Plata 800</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .8)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .8*.9)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .8*.8)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .8*.7)}</td>
              </tr>
              <tr>
                <td className="fs-8">Plata 700</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .7)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .7*.9)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .7*.8)}</td>
                <td className="fs-8 text-end"> {calculateSalePrice(agGram, .7*.7)}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-md-3  col-sm-12">
          <hr className="d-md-none"/>

          <table className="table table-bordered table-striped pt-0">
            <tbody>
              <tr><td className="fs-7">Oro 18k (710)  0%</td><td className="fs-8"> {calculateSalePrice(auGram * 0.710,1)}</td></tr>
              <tr><td className="fs-7">Oro 18k (710) 10%</td><td className="fs-8"> {calculateSalePrice(auGram * 0.710, 0.9)}</td></tr>
              <tr><td className="fs-7">Oro 18k (710) 20%</td><td className="fs-8"> {calculateSalePrice(auGram * 0.710, 0.8)}</td></tr>
              <tr><td className="fs-7">Oro 18k (710) 30%</td><td className="fs-8"> {calculateSalePrice(auGram * 0.710, 0.7)}</td></tr>
            </tbody>
          </table>
        </div>
      </>
    );
  }
  const vistaVentas = ()=>{
   
    return (
      <>
      <div className="col-md-5 col-sm-12 pt-2 pb-0">
        <h5>Oro (USD)</h5>
        <table className="table table-bordered table-striped" style={{marginBottom: 0}}>
          <thead>
              <tr>
                <th class="fs-7">Descrp</th>
                <th class="fs-7">Gr/USD</th>
                <th class="fs-7">Ozt/USD</th>
                
              </tr>

            </thead>
          <tbody>
            <tr>
              <td className="fs-7">Ling o Mon fino 12% </td>
              <td className="text-end fs-7"> {calculateSalePrice(auGram, 1.12)} <span className="fs-8"></span></td>
               <td  className="text-end fs-7"> {calculateSalePrice(auOz, 1.12)} <span className="fs-8"></span></td>
            </tr>
            
            <tr>
              <td className="fs-7">Mon 900 &gt;12gr 10%</td>
              <td  className="text-end fs-7"> {calculateSalePrice(auGram, 1.10*.9)} <span className="fs-8"></span></td>
              <td  className="text-end fs-7"> </td>
            </tr>
            <tr>
              <td className="fs-7">Mon 900 &lt;12gr 5%</td>
              <td  className="text-end fs-7">{calculateSalePrice(auGram, 1.05*.9)} <span className="fs-8"></span></td>
              <td  className="text-end fs-7"></td>
            </tr>
            <tr>
              <td className="fs-7">Mon con onza 10%</td>
              <td  className="text-end fs-7"> {calculateSalePrice(auOz, 1.1, 1)} <span className="fs-8">/un</span></td>
              <td></td>
            </tr>
            <tr>
              <td className="fs-7">Libra 7% </td>
              <td  className="text-end fs-7"> {calculateSalePrice(auGram, 1.07*.9, 1)} <span className="fs-8">/gr</span></td>
              <td></td>
            </tr>
            
            
          </tbody>
        </table>
      </div>
      <div className="col-md-4 col-sm-12 pt-0 pb-0">
        <h5>Plata (USD)</h5>
        <table className="table table-bordered table-striped" style={{marginBottom: 0}}>
          <tbody>
            <tr className=""><td className="fs-8">Mon URU 15%</td>
                <td  className="text-end fs-8">{calculateSalePrice(agGram, 1.15)} <span className="fs-8">/gr</span></td>
              <td className=""></td>
            </tr>
            <tr><td className="fs-8">Lingotes LF 15%</td>
                <td  className="text-end fs-7">{calculateSalePrice(agGram, 1.15)} <span className="fs-8">/gr</span></td>
              <td></td>
            </tr>
            <tr><td className="fs-8">Lingotes 925 25%</td>
                <td  className="text-end fs-8">{calculateSalePrice(agGram, 1.25)} <span className="fs-8">/gr</span></td>
              <td></td>
            </tr>
            <tr><td className="fs-8">Mon/Ling Int 50%</td>
                <td  className="text-end fs-7">{calculateSalePrice(agGram, 1.5)} <span className="fs-8">/gr</span></td>
                <td  className="text-end fs-7">{calculateSalePrice(agOz, 1.5)} <span className="fs-8">/oz</span></td>
            </tr>
          </tbody>
          
        </table>
        * Los precios son de plata pura por gramo hay que multiplicar por la pureza.
      </div>
      <div className="col-md-3 col-sm-12 pt-0 pb-0">
          <h5>Granalla </h5>

          <table className="table table-bordered table-striped-columns" style={{marginBottom: 0}}>
          <tbody>
            <tr><td className="fs-8">AU</td><td className="text-end"><small className="fs-8 ">{grain.au.currency_symbol}</small> {laminado_auGram}</td></tr>
            <tr className="text-white"><td className="fs-8 bg-success text-white">AG</td><td className="text-end bg-success text-white"><small className="fs-8"><b>{grain.ag.currency_symbol}</b></small>{laminado_agGram}</td></tr>
            <tr><td className="fs-8">PT</td><td  className="text-end"><small className="fs-8">{grain.pt.currency_symbol}</small>{laminado_ptGram}</td></tr>
            <tr><td className="fs-8">PD</td><td  className="text-end"><small className="fs-8">{grain.pd.currency_symbol}</small>{laminado_pdGram}</td></tr>
            <tr><td className="fs-8">Dolar </td><td className="fs-8 text-center">{laminado_Cotizacion}</td></tr>
          </tbody>
        </table>
      </div>


      </>
    );
    
  }
  const graphOptionsDesktop = ()=>{
    return {
      responsive: true,
      scales: { 
        x: { 
          type: 'time',
          time: {
            tooltipFormat: 'dd/MM/yyyy HH:mm',
            displayFormats: {
              hour: 'dd/MM',
              day: 'dd/MM',
            }
          },
          ticks: { 
            autoSkip: true, 
            maxTicksLimit: 5, 
            maxRotation: 45, 
            minRotation: 45 
          } 
        } 
      }
    };
  }
  const graphOptionsMobile = ()=>{
    return {
      responsive: true,
      scales: { 
        x: { 
          type: 'time',
          time: {
            tooltipFormat: 'dd/MM/yyyy HH:mm',
            displayFormats: {
              hour: 'dd/MM',
              day: 'dd/MM',
            }
          },
          ticks: { 
            autoSkip: true, 
            maxTicksLimit: 5, 
            maxRotation: 45, 
            minRotation: 45 
          } 
        } 
      }
    };
  }

  if (!checkedAuth) return null;           // No mostrar nada hasta revisar la clave
  if (!isAuthorized) return <h1>Hola mundo</h1>; // Clave incorrecta

  return (
    <>
    <h6 className="text-end px-2" style={{color: isStale() ? "red" : "black" }}>Actualizado {getFormattedTime()} </h6>
    <div className="d-none d-md-block" style={{width: '100%', margin: 0, padding: 0}}>
      <div className="row g-0" style={{margin: 0}}>
        <div className="col-3 row px-2" style={{margin: 0}}>
           {/* Cuadrante graph Oro */}
          <div div className="card  col-12">
            <div className="card-body">
              <h5 className="card-title text-center">Precio AU</h5>
              <hr />
              <h6 className="card-subtitle mb-2 text-body-secondary text-center">
                {formatPrice(auOz)} USD/Oz - {formatPrice(auGram)} USD/gr
              </h6>
              <Line data={formatChartData(history.au)} options= {graphOptionsDesktop()} />
            </div>
          </div>
          {/* Cuadrante Plata */}
          <div className="card col-12" >
            <div className="card-body">
              <h5 className="card-title text-center [">Precio AG</h5>
              <hr />
              <h6 className="card-subtitle mb-2 text-body-secondary text-center">
                {formatPrice(agOz)} USD/Oz - {formatPrice(agGram)} USD/gr
              </h6>
              <Line data={{
                ...formatChartData(history.ag),
                datasets: [{ ...formatChartData(history.ag).datasets[0], borderColor: "#6c757d" }],
              }} options={graphOptionsDesktop()} />
            </div>
          </div>
        </div>
        <div className="col-9 row pe-0" style={{margin: 0}}>
              {/* Cuadrante Ventas */}
              <div className="card  col-12 py-0 mb-2" >
                <div className="card-body py-0 pb-0">
                  <h5 className="card-title text-center pb-0 pt-1">Ventas</h5>
                  <hr className="mt-0 mb-1"/>
                  {/* Tus tablas de ventas */}
                  <div className="row" style={{padding: 0, margin: 0}}>
                    {vistaVentas()}
                  </div>
                </div>
              </div>
              {/* Cuadrante Compras */}
              <div className="card col-12  py-0 mb-0" >
                <div className="card-body position-relative  py-0 pb-1">
                  <h5 className="card-title text-center  pb-0 pt-1">Compras (USD)</h5>
                  <hr className="mt-0 mb-2"/>
                  <div className="row mb-0">
                    {vistaCompras()}
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>

     
    
  
      {/* Vista Mobile: Tabs */}
      <div className="d-flex flex-column d-md-none">
        <Tab.Container defaultActiveKey="oro">
          <Nav variant="tabs">
            <Nav.Item><Nav.Link eventKey="oro">Oro</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="plata">Plata</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="ventas">Ventas</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="compras">Compras</Nav.Link></Nav.Item>
          </Nav>
  
          <Tab.Content className="mt-3">
            {/* Tab Oro */}
            <Tab.Pane eventKey="oro">
              <div className="card p-3 mb-3">
                <h2>Precio AU</h2>
                
                <hr />
                <p  className="fs-6">{formatPrice(auOz)} USD/Oz - {formatPrice(auGram)} USD/gr</p>
                <Line data={formatChartData(history.au)} options= {graphOptionsDesktop()} height={350}/>
              </div>
            </Tab.Pane>
  
            {/* Tab Plata */}
            <Tab.Pane eventKey="plata">
              <div className="card p-3 mb-3">
                <h2>Precio AG</h2>
                
                <hr />
                <p className="fs-6">{formatPrice(agOz)} USD/Oz - {formatPrice(agGram)} USD/gr</p>
                <Line data={{
                  ...formatChartData(history.ag),
                  datasets: [{ ...formatChartData(history.ag).datasets[0], borderColor: "#6c757d" }]
                }} options={graphOptionsDesktop()} height={350} />
              </div>
            </Tab.Pane>
  
            {/* Tab Ventas */}
            <Tab.Pane eventKey="ventas">
              <div className="card p-3 mb-3">
                <h2 className="text-center">Ventas</h2>
                <hr />
                {vistaVentas()}
              </div>
            </Tab.Pane>
  
            {/* Tab Compras */}
            <Tab.Pane eventKey="compras">
              <div className="card p-3 mb-3 position-relative">
                <h2 className="text-center">Compras</h2>
                <hr />
                {vistaCompras()}
                
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        
      </div>
     
    </>
  );
}
